import { render, staticRenderFns } from "./customSentNotificationsSidepanel.vue?vue&type=template&id=7a47884a&scoped=true&"
import script from "./customSentNotificationsSidepanel.vue?vue&type=script&lang=js&"
export * from "./customSentNotificationsSidepanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a47884a",
  null
  
)

export default component.exports